angular.module('bmsApp.settings').factory('AccountDefaultsSvc', function ($http, $log, $window, $q, CRUDSvc, ACCOUNT_DEFAULT_API) {

    return {
        index: function (params) {
            return CRUDSvc.get(ACCOUNT_DEFAULT_API.INDEX, params);
        },
        update: function (data) {
            return CRUDSvc.post(ACCOUNT_DEFAULT_API.UPDATE, data);
        }
    }

}).constant('ACCOUNT_DEFAULT_API', {
    INDEX: 'api/settings/accountDefaults/index',
    UPDATE: 'api/settings/accountDefaults/update'
});




